module.exports = __webpack_public_path__ + "img/让设计更加接近真实.9a780f6a.png";